import React, { useEffect, useState, useCallback } from "react";

//components
import Draggable from "react-draggable";
import BareIndicator from "components/leftPanel/components/BareIndicator";

//assets
import equalizerBackground from "assets/phase2/equalizer.png";

//providers
import { useTimelineState } from "providers/TimelineProvider";
import { usePreferenceState } from "providers/PreferenceProvider";

//helpers
import _ from "lodash";

function LeftPanel({
  currentTime,
  currentTrack,
  bareSize,
  percentOfHeight,
  percentOfWidth,
  setCurrentTime,
  // defaultTempo,
}) {
  const [bottomPanelLeft, setBottomPanelLeft] = useState(0);
  const [size, setSize] = useState(bareSize);
  const [bareSizeInt, setBareSizeInt] = useState(0);
  const [scrollOffset, setScrollOffset] = useState(0);
  const [scrollX, setScrollX] = useState(0);
  const [dragStartX, setDragStartX] = useState(0);
  const [dragStartY, setDragStartY] = useState(0);
  const [lastTrack, setLastTrack] = useState(0);
  const [defaultTempo, setDefaultTempo] = useState(120);

  const [timeline, setTimeline] = useTimelineState();
  const [preferences, setPreferences] = usePreferenceState();
  const [repeats, _setRepeats] = useState([]);
  const [timestamps, setTimestamps] = useState([]);

  // const timestamps = [];

  const effectiveCount = timestamps.length + 3;
  const scrollSize = parseInt(
    percentOfWidth(100 / effectiveCount).slice(0, -2)
  );

  const setRepeats = useCallback((index, value) => {
    const newRepeats = { ...repeats };
    newRepeats[index] = value;
    _setRepeats(newRepeats);
    let newPreferences = { ...preferences };
    newPreferences.repeats = newRepeats;
    setPreferences(newPreferences);
  },[preferences, repeats, setPreferences]);

  useEffect(() => {
    if (
      preferences &&
      preferences.repeats &&
      !_.isEqual(preferences.repeats, repeats)
    ) {
      _setRepeats(preferences.repeats);
    }
  }, [preferences, repeats]);

  useEffect(() => {
    if (!timeline || !timeline.timestamps) return;
    let newTimestamps = [];
    for (let i = 0; i < timeline.timestamps.length - 1; i++) {
      newTimestamps.push({
        startTime: timeline.timestamps[i],
        endTime: timeline.timestamps[i + 1],
      });
    }
    setTimestamps(newTimestamps);
    setDefaultTempo(timeline.defaultTempo);
  }, [timeline]);

  useEffect(() => {
    if (size && currentTrack) {
      setBottomPanelLeft(-1 * currentTrack * parseInt(size.slice(0, -2)));
      setScrollX(
        Math.max(0, currentTrack - 3) * parseInt(size.slice(0, -2)) -
          parseInt(percentOfWidth(4).slice(0, -2))
      );
      setBareSizeInt(parseInt(size.slice(0, -2)));
    }
  }, [currentTrack, size, percentOfWidth]);

  useEffect(() => {
    setBottomPanelLeft(-1 * Math.max(currentTrack - 3, 0) * bareSizeInt);
    setScrollX(
      Math.max(0, currentTrack - 3) * scrollSize -
        parseInt(percentOfWidth(4).slice(0, -2))
    );
  }, [currentTrack, bareSizeInt, scrollSize, percentOfWidth]);

  useEffect(() => {
    if (lastTrack === currentTrack) return;
    if (repeats[lastTrack - 1] > 1) {
      setCurrentTime(timestamps[lastTrack - 1].startTime);
      setRepeats(lastTrack - 1, repeats[lastTrack - 1] - 1);
      return;
    }
    if (repeats[currentTrack - 1] < 1) {
      if (currentTrack - 1 >= repeats.length - 1) {
        setCurrentTime(timestamps[currentTrack - 1].endTime);
        return;
      }
      setCurrentTime(timestamps[currentTrack - 1 + 1].startTime);
      return;
    }

    setLastTrack(currentTrack);
  }, [
    currentTrack,
    lastTrack,
    repeats,
    timestamps,
    currentTime,
    setRepeats,
    setLastTrack,
    setCurrentTime,
  ]);

  useEffect(() => {
    if (repeats[currentTrack - 1] < 1) {
      if (currentTrack - 1 >= repeats.length - 1) {
        setCurrentTime(timestamps[currentTrack - 1].endTime);
        return;
      }
      setCurrentTime(timestamps[currentTrack - 1 + 1].startTime);
      return;
    }
  }, [currentTrack, currentTime, repeats, timestamps, setCurrentTime]);

  useEffect(() => {
    setBareSizeInt(parseInt(size?.slice(0, -2)));
  }, [size]);

  useEffect(() => {}, [bottomPanelLeft]);

  useEffect(() => {}, [scrollX]);

  const handleDrag = (e, ui) => {
    e.stopPropagation();
    const { x, y } = ui;
    setScrollOffset(scrollOffset + ui.deltaX);
    setScrollX(x);
    const correctedOffset = scrollOffset + ui.deltaX;
    const startIndex =
      correctedOffset /
      parseInt(percentOfWidth(100 / effectiveCount).slice(0, -2));
    setBottomPanelLeft(-1 * Math.max(0, startIndex - 3) * bareSizeInt);
  };

  return (
    <>
      <div
        style={{
          height: "30%",
          width: "100%",
          backgroundColor: "#222222",
          backgroundImage: `url(${equalizerBackground})`,
          backgroundSize: "contain",
        }}
      >
        <Draggable
          axis="x"
          onDrag={handleDrag}
          bounds="parent"
          position={{ x: scrollX, y: 0 }}
          test={scrollX}
        >
          <div
            style={{
              height: "100%",
              width: percentOfWidth((100 / effectiveCount) * 5),
              backgroundColor: "#ffffff50",

              marginRight: percentOfWidth(-4),
              marginLeft: percentOfWidth(4),
            }}
          ></div>
        </Draggable>
      </div>
      <div
        style={{
          display: "inline-flex",
          backgroundColor: "#222222",
          position: "relative",
          left: bottomPanelLeft,
          transition: "left 0.5s ease-in-out",
        }}
      >
        {timestamps.map((timestamp, index) => {
          if (repeats[index] <= -1) {
            return;
          }
          return (
            <div
              draggable
              id={index + 1}
              startTime={timestamp.startTime}
              style={{
                height: bareSize,
                width: bareSize,
                padding: `${bareSizeInt / 7}px`,
                borderRightColor: "#c1995d80",
                borderRightWidth: "1.5px",
                borderRightStyle: "solid",
                borderTopColor: "#c1995d80",
                borderTopWidth: "1.5px",
                borderTopStyle: "solid",
                position: "relative",
                // boxShadow: "0px 0px 10px 0px ##f1795d70",
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (repeats[index] < 1) return;
                setCurrentTime(timestamp.startTime);
              }}
              onTouchStart={(e) => {
                setDragStartX(e.targetTouches[0].clientX);
                setDragStartY(e.targetTouches[0].clientY);
              }}
              onTouchEnd={(e) => {
                // e.stopPropagation();
                const deltaX = e.changedTouches[0].clientX - dragStartX;
                const deltaY = e.changedTouches[0].clientY - dragStartY;
                if (
                  Math.abs(deltaY) > Math.abs(deltaX) &&
                  Math.abs(deltaY) > 10
                ) {
                  if (deltaY < 0) {
                    if (repeats[index] > 1) {
                      setRepeats(index, Infinity);
                    } else {
                      setRepeats(index, repeats[index] + 1);
                    }
                  } else {
                    if (repeats[index] == Infinity) {
                      setRepeats(index, 2);
                    } else if (repeats[index] == 0) {
                      setRepeats(index, repeats[index] - 1);
                    } else {
                      setRepeats(index, repeats[index] - 1);
                    }
                  }
                }
              }}
              onDragStart={(e) => {
                e.stopPropagation();
                setDragStartX(e.clientX);
                setDragStartY(e.clientY);
              }}
              onDragEnd={(e) => {
                e.stopPropagation();
                const deltaX = e.clientX - dragStartX;
                const deltaY = e.clientY - dragStartY;
                if (
                  Math.abs(deltaY) > Math.abs(deltaX) &&
                  Math.abs(deltaY) > 10
                ) {
                  if (deltaY < 0) {
                    if (repeats[index] > 1) {
                      setRepeats(index, Infinity);
                    } else {
                      setRepeats(index, repeats[index] + 1);
                    }
                  } else {
                    if (repeats[index] == Infinity) {
                      setRepeats(index, 2);
                    } else if (repeats[index] == 0) {
                      setRepeats(index, repeats[index] - 1);
                    } else {
                      setRepeats(index, repeats[index] - 1);
                    }
                  }
                }
              }}
            >
              <div
                style={{
                  height: "20%",
                  width: "20%",
                  left: "0",
                  top: "0",
                  display: "flex",
                  justifyContent: "center",
                  position: "absolute",
                  color: "#00ff00",
                }}
              >
                {repeats[index] == 2 && "x2"}
                {repeats[index] == Infinity && "∞"}
              </div>

              {
                <BareIndicator
                  bareNumber={index + 1}
                  repeat={repeats[index]}
                  defaultTempo={defaultTempo}
                  currentTime={currentTime}
                  startTime={timestamp.startTime}
                  endTime={timestamp.endTime}
                  sepratorColor={"#222222"}
                  totalBares={timestamps.length}
                  size={`${bareSizeInt * 0.45}px`}
                />
              }
            </div>
          );
        })}
      </div>
    </>
  );
}

export default LeftPanel;
